import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ConversationalSimulationRunPageForNRO = lazy(() =>
  import("@scenes/ConversationalSimulations").then((module) => ({
    default: module.ConversationalSimulationRunPage,
  }))
);

export const conversationalSimulationRunNRO: NavigationRoutingObject = {
  Component: ConversationalSimulationRunPageForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  heading: (t: I18nT<"dashboard-navigation">) => t("conversational-simulation-run-nro-heading", "Simulation Run"),
  pageNameForTracking: () => "Conversational Simulation Run",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("agent_console_conversational");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/conversational/simulations/:appGroupId",
};
